import React from 'react';
import { useGeneralHooks } from '../../../../../../Hooks/hooks';
import Button from '../../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../../Interfaces/componentTypes';
import { Warning } from '../../../../../../Assets/Icons';
import styles from './styleVerificationDialog.module.scss';

interface IProps {
    onClose: () => void;
    onFix: () => void;
    onSkip: () => void;
    errors: string[];
};

const StyleVerificationDialog: React.FC<IProps> = ({ onClose, onFix, onSkip, errors }) => {
    const { t } = useGeneralHooks();

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div>
                    <img src={Warning} alt='WarningIcon' />
                    <p>{t('My_Business.Templates.Validation.Title')}</p>
                </div>
            </div>
            <div className={styles.body}>
                <p className={styles.description}>
                    {t('My_Business.Templates.Validation.Description')}
                </p>
                <div className={styles.errorsList}>
                    <h4>{t('My_Business.Templates.Validation.ErrorsFound')}:</h4>
                    <ul>
                        {errors.map((error, index) => (
                            <li key={index}>{error}</li>
                        ))}
                    </ul>
                </div>
                <div className={styles.buttonsRow}>
                    <Button
                        type='button'
                        buttonType={ButtonTypes.Secondary}
                        title={t('My_Business.Templates.Validation.Skip')}
                        onClick={onSkip}
                    />
                    <Button
                        type='button'
                        buttonType={ButtonTypes.Primery}
                        title={t('My_Business.Templates.Validation.Fix')}
                        onClick={onFix}
                    />
                </div>
            </div>
        </div>
    );
};

export default StyleVerificationDialog;
